import React from 'react';
import { useTranslate } from '@hooks';
import { TablePaginated } from '@dotone/react-ui-core';
import InviteAction from './MarketplaceInviteAction';
import {
  formatCategoryGroups,
  formatNetworkHistory,
  formatNetworkPerformance,
} from '../Affiliates/formatters';
import { formatAffiliate, formatSiteInfos } from '../formatters';

const getColumns = (t, offerId, tHint) => [
  {
    dataField: 'id',
    text: t('::common:model.affiliate'),
    formatter: (cell, row) => formatAffiliate(row),
  },
  {
    dataField: 'categoryGroups',
    text: t('categoryGroups'),
    formatter: (cell) => (cell.length ? formatCategoryGroups(cell) : t('common:na')),
  },
  {
    dataField: 'siteInfos',
    text: t('siteInfos'),
    formatter: (cell) =>
      cell.length ? formatSiteInfos(cell, { canAccess: true }) : t('common:na'),
  },
  {
    dataField: 'country.region',
    text: t('region'),
    headerAlign: 'center',
    classes: 'text-center',
  },
  {
    dataField: 'networkPerformance',
    text: t('affiliate:model.networkPerformance'),
    hintProps: { t, tKey: 'affiliate:hints.networkPerformance' },
    formatter: (cell, row) => formatNetworkPerformance(row, t, tHint, 'table'),
  },
  {
    dataField: 'networkHistory',
    text: t('affiliate:model.networkHistory'),
    hintProps: { t, tKey: 'affiliate:hints.networkHistory' },
    formatter: (cell, row) => formatNetworkHistory(row, t),
  },
  {
    dataField: '',
    text: '',
    formatter: (cell, row) => (
      <InviteAction affiliate={row} offerId={offerId} buttonProps={{ size: 'sm' }} />
    ),
  },
];

const MarketplaceTable = (props) => {
  const { t, tHint } = useTranslate('marketplace', 'model');

  const { offerId } = props.tableProps.filters;
  const columns = getColumns(t, offerId, tHint);

  return (
    <TablePaginated
      remote
      condensed
      responsive
      hover
      classes="stylish-table text-sm"
      columns={columns}
      {...props}
    />
  );
};

export default MarketplaceTable;
